import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Moon } from 'lucide-react';
export function BedtimeDread() {
  return <section className="py-12 px-4 bg-navy-900 text-white" data-id="element-3">
      <div className="max-w-3xl mx-auto text-center" data-id="element-4">
        <FadeIn data-id="element-5">
          <div className="inline-flex items-center justify-center p-3 bg-navy-800 rounded-full mb-4" data-id="element-6">
            <Moon className="text-amber-500 h-8 w-8" data-id="element-7" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-8">
            The Real Enemy: Bedtime Dread
          </h2>

          <div className="space-y-6 text-lg-body text-blue-50 leading-relaxed text-left max-w-2xl mx-auto" data-id="element-9">
            <p data-id="element-10">Most men don't quit CPAP because they don't care.</p>
            <p className="text-xl font-medium text-white" data-id="element-11">
              They quit because bedtime turns into a test they keep failing.
            </p>
            <p data-id="element-12">After a week or two, you start anticipating it:</p>

            <ul className="space-y-3 my-8 bg-navy-800 p-6 rounded-lg border border-navy-700" data-id="element-13">
              {['"What\'s going to leak tonight?"', '"Am I going to run out of water again?"', '"Will I wake up panicked?"', '"How many hours did I actually get?"'].map((item, i) => <li key={i} className="flex items-center text-blue-100" data-id="element-14">
                  <span className="text-amber-500 mr-3 text-xl" data-id="element-15">•</span>
                  {item}
                </li>)}
            </ul>

            <p data-id="element-16">And that dread becomes the main thing keeping you awake.</p>
          </div>
        </FadeIn>
      </div>
    </section>;
}